
// resellingPriceApi.js
import axios from "axios";

const RESELLING_PRICE_API_SERVICE = `${process.env.REACT_APP_API_URL}/adminservice/api/pricing`;

const apiClient = axios.create({
  baseURL: RESELLING_PRICE_API_SERVICE,
  withCredentials: true,
});

const resellingPriceApi = {
  // CREATE new pricing
  // CREATE
  setPrice: (email, payload) =>
    apiClient.post(`/setPrice?email=${encodeURIComponent(email)}`, payload),

  // UPDATE
  updatePrice: (id, email, payload) =>
    apiClient.put(
      `/updatePrice/${id}?email=${encodeURIComponent(email)}`,
      payload
    ),
    
  // GET seller details and pricing
  getSellerDetails: (email) =>
    apiClient.get(
      `/seller-details?email=${encodeURIComponent(email)}`
    ),

  // GET parent/L1 pricing
  getParentPrices: (email) =>
    apiClient.get(
      `/parent-prices?email=${encodeURIComponent(email)}`
    ),
};

export default resellingPriceApi;
